module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "condition_box clearfix"
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.detileParams
    }
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', [_c('span', {
    staticClass: "inp_title"
  }, [_vm._v("申请人姓名:")])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form_item"
  }, [_c('el-input', {
    staticClass: "inp_item",
    attrs: {
      "placeholder": "姓名"
    },
    model: {
      value: (_vm.detileParams.requesterName),
      callback: function($$v) {
        _vm.$set(_vm.detileParams, "requesterName", $$v)
      },
      expression: "detileParams.requesterName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('span', {
    staticClass: "inp_title"
  }, [_vm._v("申请人电话:")])]), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticClass: "inp_item",
    attrs: {
      "placeholder": "电话"
    },
    model: {
      value: (_vm.detileParams.requesterPhoneNum),
      callback: function($$v) {
        _vm.$set(_vm.detileParams, "requesterPhoneNum", $$v)
      },
      expression: "detileParams.requesterPhoneNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('span', {
    staticClass: "inp_title"
  }, [_vm._v("所在单位:")])]), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticClass: "inp_item",
    attrs: {
      "placeholder": "单位"
    },
    model: {
      value: (_vm.detileParams.requesterOrganisation),
      callback: function($$v) {
        _vm.$set(_vm.detileParams, "requesterOrganisation", $$v)
      },
      expression: "detileParams.requesterOrganisation"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', [_c('span', {
    staticClass: "inp_title"
  }, [_vm._v("待撤文章题目:")])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form_item"
  }, [_c('el-input', {
    staticClass: "inp_item",
    attrs: {
      "placeholder": "待撤文章题目"
    },
    model: {
      value: (_vm.detileParams.articleName),
      callback: function($$v) {
        _vm.$set(_vm.detileParams, "articleName", $$v)
      },
      expression: "detileParams.articleName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('span', {
    staticClass: "inp_title"
  }, [_vm._v("待撤文章作者:")])]), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticClass: "inp_item",
    attrs: {
      "placeholder": "待撤文章作者"
    },
    model: {
      value: (_vm.detileParams.author),
      callback: function($$v) {
        _vm.$set(_vm.detileParams, "author", $$v)
      },
      expression: "detileParams.author"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('span', {
    staticClass: "inp_title"
  }, [_vm._v("撤除类型")])]), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "placeholder": "请选择撤除类型"
    },
    model: {
      value: (_vm.detileParams.commitType),
      callback: function($$v) {
        _vm.$set(_vm.detileParams, "commitType", $$v)
      },
      expression: "detileParams.commitType"
    }
  }, _vm._l((_vm.commitTypeList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', [_c('el-button', {
    staticClass: "chaxun_btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.searchData
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table_box"
  }, [_c('el-button', {
    staticClass: "chegao_btn",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.BatchRequestExecuteFn
    }
  }, [_vm._v("批量成功撤除")]), _vm._v(" "), _c('my-table', {
    attrs: {
      "items": _vm.tableDataDetail,
      "headers": _vm.tableHeaderDetail,
      "oprateBtns": _vm.oprateBtns,
      "selectShow": true,
      "oprateOption": _vm.oprateOption,
      "listLoading": _vm.listLoadingDetail,
      "totalNum": _vm.TotalNumDetail,
      "pageSize": _vm.detileParams.pageSize
    },
    on: {
      "selecChange": _vm.selecChangeFn,
      "getTableData": _vm.getTableDataDetail
    },
    scopedSlots: _vm._u([{
      key: "caozuo",
      fn: function(ref) {
        var props = ref.props;

        return [_c('span', {
          staticClass: "caozuo_span",
          on: {
            "click": function($event) {
              return _vm.getDetailPage(props.row)
            }
          }
        }, [_vm._v("查看")])]
      }
    }, {
      key: "CheckStatusText",
      fn: function(ref) {
        var props = ref.props;

        return [_c('span', [_vm._v(_vm._s(props.row.CheckStatusText))])]
      }
    }, {
      key: "CommitType",
      fn: function(ref) {
        var props = ref.props;

        return [_c('span', [_vm._v(_vm._s(props.row.CommitTypes))])]
      }
    }])
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-df2f8a0c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/operatorPages/cancelInfo.vue
// module id = 1206
// module chunks = 1